import Vue from 'vue'
import Router from 'vue-router'
import Full from '@/containers/Full'
import Dashboard from '@/views/Dashboard'
import Login from '@/views/pages/Login'
import Inventario from '@/views/inventario'
import Abonos from '@/views/abonos'
import Venta from '@/views/venta'
import Ventas from '@/views/ventas'
import Reportes from '@/views/reportes'
import Mensajes from '@/views/mensajes'
import CerrarSesion from '@/views/cerrarSesion/cerrarSesion'


import Clientes from '@/views/clientes'



Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: '/punto_venta/',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/main',
      name: 'Home',
      component: Full,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          beforeEnter: (to, from, next) => {
            if(
              localStorage.getItem('username')!='')

          {
             next()
          }else{
           
          }
          }
        },
        {
          path:'/clientes',
          name:'Clientes',
          component:Clientes,
          beforeEnter: (to, from, next) => {
            if((localStorage.getItem("permission")==1 || localStorage.getItem("permission")==2)
            &&               localStorage.getItem('username')!='')
 
           {
              next()
           }else{
            
           }
          }
        },
        {
          path:'/abonos',
       name:'Abonos',
       component:Abonos,
       beforeEnter: (to, from, next) => {
        if((localStorage.getItem("permission")==1 || localStorage.getItem("permission")==2)
        &&               localStorage.getItem('username')!='')

       {
          next()
       }else{
      
       }
      }

        },{
          path:'/venta',
          name:'Venta',
          component: Venta,
          beforeEnter: (to, from, next) => {
            if((localStorage.getItem("permission")==1 || localStorage.getItem("permission")==2)
            &&               localStorage.getItem('username')!='')
 
           {
              next()
           }else{
           
           }
          }
        },
       {path:'/inventario',
       name:'Inventario',
       component:Inventario,
       beforeEnter: (to, from, next) => {
        if((localStorage.getItem("permission")==1 || localStorage.getItem("permission")==2)
        &&               localStorage.getItem('username')!='')

       {
          next()
       }else{
        
       }
      }

       },
       {
         path:'/ventas',
         name:'Ventas',
         component:Ventas,
         beforeEnter: (to, from, next) => {
          if((localStorage.getItem("permission")==1 || localStorage.getItem("permission")==2)
           &&               localStorage.getItem('username')!='')

          {
             next()
          }else{
           
          }
        }
       },
       {
        path:'/reportes',
        name:'Reportes',
        component:Reportes,
        beforeEnter: (to, from, next) => {
          if(
            localStorage.getItem('username')!='')

        {
          next()
        }else{
        
        }
        }
      },
        
        {
          path: '/cerrarSesion',
          name: 'Cerrar Sesion',
          component: CerrarSesion
        }
      ]
    },
    {
      path: '/',
      name: 'login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js